const PREFIX = 'uf/amplitude';

export const INITIALIZE = `${PREFIX}/INITIALIZE`;
export const UPDATE = `${PREFIX}/UPDATE`;
